import { createAction, props, union } from '@ngrx/store';
import { QuaLoadingListQueryI } from 'src/app/api/qua-loading-list/qua-loading-list.query.int';
import { QuaLoadingListI } from 'src/app/api/qua-loading-list/qua-loading-list.result.int';

export const error = createAction('[QUA / Full Loading List] Error', props<{
    messageText: string;
}>());
export const load = createAction('[QUA / Full Loading List] Get', props<{
    query: QuaLoadingListQueryI;
}>());
export const received = createAction('[QUA / Full Loading List] Received', props<{
    result: QuaLoadingListI;
}>());
export const reset = createAction('[QUA / Full Loading List] Reset', props<Record<string, unknown>>());

const all = union({
    error,
    load,
    received,
    reset,
});
export type Actions = typeof all;
